import { Swiper } from "swiper/react";
import SwiperCore, { Scrollbar, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "./style.css";
import vector from "../../Assets/Images/arrow/Vector.svg";

SwiperCore.use([Scrollbar, Navigation]);

export default function Carousel(props) {
  const newOptions = props.newOptions;
  const breakpoints = props.breakpoints;

  const defaultOptions = {
    slidesPerView: 2.5,
    spaceBetween: 10,
    scrollbar: { hide: true },
    className: "mySwiper",
    navigation: true,
    ...newOptions,
  };

  const mergedOptions = {
    ...defaultOptions,
    breakpoints: {
      ...defaultOptions.breakpoints,
      ...breakpoints,
    },
  };

  return (
    <div className="swiper-layer">
      <div className={`swiper-button ${props.id}-button-prev`}>
        <img src={vector} className="arrow-pre" alt="Previous" />
      </div>
      <div className={`swiper-button ${props.id}-button-next swiper-button-disabled`}>
        <img src={vector} className="arrow-nex" alt="Next" />
      </div>
      <Swiper
        {...mergedOptions}
        navigation={{
          nextEl: `.${props.id}-button-next`,
          prevEl: `.${props.id}-button-prev`,
        }}
      >
        {props.children}
      </Swiper>
    </div>
  );
}
